import { render } from "./FormToggleSwitch.vue?vue&type=template&id=55531977&scoped=true&ts=true"
import script from "./FormToggleSwitch.vue?vue&type=script&lang=ts"
export * from "./FormToggleSwitch.vue?vue&type=script&lang=ts"

import "./FormToggleSwitch.vue?vue&type=style&index=0&id=55531977&lang=scss&scoped=true"

import exportComponent from "/home/marcin/www/orchidea-event-services/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55531977"]])

export default __exports__